var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('el-backtop',{attrs:{"target":""}}),_c('Video'),(true)?_c('Nosotros',{attrs:{"id":""}}):_vm._e(),(true)?_c('Canal',{attrs:{"id":""}}):_vm._e(),_c('Footer',{attrs:{"id":"contacto"}}),_c('el-row',[_c('el-col',[_c('h6',{staticClass:"footer-final"},[_c('center',[_vm._v(_vm._s(_vm.altEmpresa))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }